import { useEffect, useState } from "react";
import { PreviewComponentConfig } from "@/pages/quiz/context/types";

const SecondDiv: React.FC<{ onClosePreview: () => void }> = ({
  onClosePreview,
}) => {
  return (
    <div>
      <div
        className="opacity-0 animate-fade-in mb-4"
        style={{ animationDelay: "0.5s" }}
      >
        We found <b className="text-dark-purple-2">providers</b> near you..
      </div>

      <div
        className="opacity-0 animate-fade-in mb-4"
        style={{ animationDelay: "2.5s" }}
      >
        Lose up to <b className="text-dark-purple-2">2-5 lbs</b> per week on{" "}
        <b className="text-dark-purple-2">Semaglutide</b> or{" "}
        <b className="text-dark-purple-2">Tirzepatide</b>.
      </div>

      <div
        className="flex justify-end opacity-0 animate-fade-in"
        style={{ animationDelay: "3.5s" }}
      >
        <button
          onClick={onClosePreview}
          className="text-white text-lg bg-[#362068] rounded-full px-4 py-2 font-bold mt-14 min-w-[150px]"
        >
          Next
        </button>
      </div>
    </div>
  );
};

const PreviewSelectTreatmentOption: React.FC<PreviewComponentConfig> = ({
  onClosePreview,
}) => {
  const [showSecondDiv, setShowSecondDiv] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSecondDiv(true);
    }, 8000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-1 items-center">
      {!showSecondDiv ? (
        <div>
          <div
            className="mb-4 opacity-0 animate-fade-in"
            style={{ animationDelay: "0.5s" }}
          >
            Checking our database..
          </div>
          <div
            className="opacity-0 animate-fade-in"
            style={{ animationDelay: "2.5s" }}
          >
            We only work with{" "}
            <b className="text-dark-purple-2">
              licensed providers in your state
            </b>{" "}
            who specialize in weight loss.
          </div>

          <div
            className="flex justify-end opacity-0 animate-fade-in"
            style={{ animationDelay: "3.5s" }}
          >
            <button
              onClick={() => setShowSecondDiv(true)}
              className="text-white text-lg bg-[#362068] rounded-full px-4 py-2 font-bold mt-14 min-w-[150px]"
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        <SecondDiv onClosePreview={onClosePreview} />
      )}
    </div>
  );
};

export { PreviewSelectTreatmentOption };
